import { useParams } from 'react-router-dom';
import { KeyedMutator } from 'swr';

import { useCanAlignEvaluators } from '@/hooks/useCanAlignEvaluators';
import { useRunRules } from '@/hooks/useSwr';
import { RuleSchema } from '@/types/schema';

type AlignEvaluatorInfo = {
  isAlignEvaluatorV2: boolean;
  evaluatorId: string | undefined;
  alignmentDatasetId: string | undefined;
  originalDatasetId: string | undefined;
  originalSessionId: string | undefined;
  isLoading: boolean;
  hubRef: string | undefined;
  commitHash: string | undefined;
  rule: RuleSchema | undefined;
  mutateRunRules: KeyedMutator<RuleSchema[]>;
};

export const useAlignEvaluatorInfo = (): AlignEvaluatorInfo => {
  const { evaluatorId: _evaluatorId } = useParams();

  const {
    areEvaluatorsAlignable,
    isLoading: isLoadingEnableAlignEvaluatorsV2,
  } = useCanAlignEvaluators();

  const evaluatorId = areEvaluatorsAlignable ? _evaluatorId : undefined;

  const rule = useRunRules(evaluatorId ? { id: [evaluatorId] } : null);

  const alignmentDatasetId = rule.data?.[0]?.corrections_dataset_id;
  const originalDatasetId = rule.data?.[0]?.dataset_id;
  const originalSessionId = rule.data?.[0]?.session_id;
  const isLoading =
    (rule.isLoading || isLoadingEnableAlignEvaluatorsV2) && !!_evaluatorId;
  const hubRef =
    rule.data?.[0]?.evaluators?.[0]?.structured?.['hub_ref']?.split(':')?.[0];
  const commitHash =
    rule.data?.[0]?.evaluators?.[0]?.structured?.['hub_ref']?.split(':')?.[1];

  return {
    isAlignEvaluatorV2: !!evaluatorId,
    evaluatorId,
    alignmentDatasetId,
    originalDatasetId,
    originalSessionId,
    isLoading,
    hubRef,
    commitHash: commitHash ?? undefined,
    mutateRunRules: rule.mutate,
    rule: rule.data?.[0],
  };
};
